import { FilterPersonVM, FilterPracticeVM } from 'practice/view-models/practice-research';
import { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';
import { useUserProfile } from 'shell/hooks/use-user-profile';
import FilterTableProvider from 'shell/hooks/use-filter-table/provider';

export interface IdentifyChildAndTypeOfSearch {
  isChildComponentVisited?: boolean;
  searchType?: PracticeFilterSearchType;
}

export enum PracticeFilterSearchType {
  SEARCH_BY_PRATICE = 'SEARCH_BY_PRATICE',
  SEARCH_BY_PERSON = 'SEARCH_BY_PERSON',
}
export const initialValuesPraticeSearch: PracticeSearchType = {
  typeRegister: undefined,
  fromNumber: undefined,
  atNumber: undefined,
  dateFrom: null,
  years: undefined,
  isChildComponentVisited: false,
  fiscalCode: '',
  operatorCode: undefined,
  surname: '',
  withoutSurname: false,
  name: '',
  withoutName: false,
  gender: '',
  birthDate: null,
  municipality: null,
  isForeign: false,
  foreignState: null,
  searchType: undefined,
};
export type PracticeSearchType = FilterPersonVM & FilterPracticeVM & IdentifyChildAndTypeOfSearch;
const StoragePersonPage = (): ReactElement => {
  const { userProfile } = useUserProfile();
  const authPerson = userProfile.datiLogin?.profile?.feature?.filtroPraticaServizioOperatore || '';

  return (
    <FilterTableProvider
      initialValues={{ ...initialValuesPraticeSearch, onlyPracticeAssigned: authPerson === '0' }}
    >
      <Outlet />
    </FilterTableProvider>
  );
};

StoragePersonPage.displayName = 'Storage Research practice initializer component';

export default StoragePersonPage;
